import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { AuthContext } from "../../contexts/auth";
import { useNavigate, useParams } from "react-router-dom";

import { set, useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { permite_acesso, total_monitora, metas_unidades, novos_renovados_unidade, anuidade_unidades } from "../../services/api";

import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import Col from "react-bootstrap/esm/Col";

import Accordion from 'react-bootstrap/Accordion';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import InputGroup from 'react-bootstrap/InputGroup';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';
import Collapse from 'react-bootstrap/Collapse';

import Table from 'react-bootstrap/Table';
import ProgressBar from 'react-bootstrap/ProgressBar';

import Carrocel from '../Components/carrocel';

import './index.css';

const schema = yup.object({}).required();


const Metas_Painel = (props) => {

    const perfil = JSON.parse(localStorage.getItem("perfil"));

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']

    const usuario = JSON.parse(localStorage.getItem("user"));
    const token = localStorage.getItem("token");

    // CONTROLE(FUNCIONARIO,TOKEN,COD_UNI)

    const { authenticated, logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const [acesso, setAcesso] = useState(false);



    const [dataInicio, setDataInicio] = useState('2024-08-31'); // Formato ISO (YYYY-MM-DD) 
    // const [dataFim, setDataFim] = useState(new Date().toISOString().split('T')[0]);
    // const [dataFim, setDataFim] = useState('2025-03-31');
    const amanha = new Date();
    amanha.setDate(amanha.getDate() + 1);
    const novaDataFim = amanha.toISOString().split('T')[0];
    const hoje = new Date();
    const diadehoje = hoje.toISOString().split('T')[0];

    const [dataFim, setDataFim] = useState(diadehoje);

    function formatarData(dataOriginal) {
        // Divide a string da data em ano, mês e dia
        const partes = dataOriginal.split('-');
        // Verifica se a string está no formato correto (ANO-MES-DIA)
        if (partes.length !== 3) {
            return 'Formato de data inválido';
        }
        // Reorganiza as partes da data no formato DIA-MES-ANO
        const dataFormatada = `${partes[2]}-${partes[1]}-${partes[0]}`;
        return dataFormatada;
    }
    const [data25, setData25] = useState([]);
    const [dataA, setDataA] = useState([]);
    const [dataM, setDataM] = useState([]);
    const [isLoading1, setIsLoading1] = useState(true);
    const [isLoading2, setIsLoading2] = useState(true);
    const [isLoading3, setIsLoading3] = useState(true);

    console.log("Antes", dataInicio);

    // const [startDate, setStartDate] = useState('2023-09-01');
    // const [endDate, setEndDate] = useState(getCurrentDate());




    const {
        register,
        setValue,
        handleSubmit,
        setFocus,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });


    console.log("Acesso:", acesso);

    console.log("Depois", dataInicio);

    const handleData = (e) => {
        e.preventDefault();
        let dti = document.querySelector(
            "input[name = inicio]"
        ).value;
        console.log(dti);
        setDataInicio(dti);
        let dtf = document.querySelector(
            "input[name = fim]"
        ).value;
        console.log(dtf);
        setDataFim(dtf);

    };

    const Experiment = (Nperfil) => {
        if (Nperfil === "GESTOR")
            return (
                <>
                    <NavDropdown.Item href="/unidade/10">Barra da Tijuca</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/01">Bento Ribeiro</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/11">Campo Grande</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/04">Cascadura</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/16">Freguesia</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/15">Ilha do Governador</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/02">Madureira</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/14">Maricá</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/06">Nilópolis</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/17">Recreio</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/03">Santa Cruz</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/09">Seropédica</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/05">Taquara</NavDropdown.Item>
                    <NavDropdown.Item href="/metas">Painel de Metas</NavDropdown.Item>

                </>
            );
        if (Nperfil.startsWith("DIRETOR")) {
            var numerosString = Nperfil.replace("DIRETOR", "").trim();
            var numerosArray = numerosString.split("-");
            var codigoDinamico = numerosArray.map(function (cod_unidade) {
                return (
                    <NavDropdown.Item href={`/unidade/${cod_unidade}`}>
                        {unidades[parseInt(cod_unidade)]}
                    </NavDropdown.Item>
                );
            });
            codigoDinamico.push(<NavDropdown.Item key="tesouraria" href="/tesouraria"> Tesouraria - Pagamentos </NavDropdown.Item>);
            codigoDinamico.push(<NavDropdown.Item href="/metas">Painel de Metas</NavDropdown.Item>);


            return (codigoDinamico)


        };
        if (Nperfil.startsWith("SECRETARIA")) {
            var numerosString = Nperfil.replace("SECRETARIA", "").trim();
            var numerosArray = numerosString.split("-");
            var codigoDinamico = numerosArray.map(function (cod_unidade) {
                return (
                    <NavDropdown.Item href={`/unidade/${cod_unidade}`}>
                        {unidades[parseInt(cod_unidade)]}
                    </NavDropdown.Item>
                );
            });
            codigoDinamico.push(<NavDropdown.Item href="/metas">Painel de Metas</NavDropdown.Item>);
            codigoDinamico.push(<NavDropdown.Item key="tesouraria" href="/tesouraria"> Tesouraria - Pagamentos </NavDropdown.Item>);

            return (codigoDinamico)
        };


    }

    const handleCiclo = (e) => {
        e.preventDefault();
        console.log('2026-08-28');
        setDataInicio('2026-08-28');
        console.log('2027-03-31');
        setDataFim('2027-03-31');
    };

    const handleHoje = (e) => {
        e.preventDefault();
        console.log('2026-08-28');
        setDataInicio('2026-08-28');
        console.log('novaDataFim');
        setDataFim(diadehoje);
    };

    const handleSoHoje = (e) => {
        e.preventDefault();
        console.log(diadehoje);
        setDataInicio(diadehoje);
        console.log('novaDataFim');
        setDataFim(diadehoje);
    };


    let data_inicio = dataInicio;
    let data_fim = dataFim;

    console.log("Data inicio:", data_inicio);
    console.log("Data Fim:", data_fim);


    const meu_perfil = perfil[0].perfil;




    const fetchData = async () => {
        try {
            try {
                const response = await anuidade_unidades(data_inicio, data_fim);
                setDataA(response);
            } catch (erro) {
                console.error('Erro ao carregar dados:', erro);
            } finally {
                setIsLoading1(false);
            };
            try {
                const responseM = await metas_unidades(data_inicio, data_fim);
                setDataM(responseM);
            } catch (erro) {
                console.error('Erro ao carregar dados:', erro);
            } finally {
                setIsLoading2(false);
            };
            try {
                console.log("DATA25: i F", data_inicio, data_fim);
                const response3 = await novos_renovados_unidade(data_inicio, data_fim);
                setData25(response3);
            } catch (erro) {
                console.error('Erro ao carregar dados:', erro);
            } finally {
                setIsLoading3(false);
            }

        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [data_inicio, data_fim]);

    console.log("DATA25:", data25);

    let chartData = [];

    // if ((typeof data25 !== 'undefined') && (typeof dataA !== 'undefined') && (typeof dataM !== 'undefined')) {
    if ((!isLoading1) && (!isLoading2) && (!isLoading3)) {
        console.log("data25", data25);
        console.log("dataA", dataA);
        console.log("dataM", dataM);
        let DataB = dataA.filter(item => item.sec !== 13);
        chartData = DataB.map((item, index) => {
            const row = [unidades[parseInt(item.sec)]];
            let cod_unidade = item.sec;
            console.log("cod_unidade", cod_unidade);
            let Total = 0;
            let indice = 0;
            let Renovados = 0;
            if ((typeof data25 !== 'undefined') && (data25 !== "")) {
                indice = data25.findIndex(data25 => data25.unidade === cod_unidade)

                console.log("indice ", indice)
            };

            if (indice !== -1) {
                Total = parseInt(data25[indice].novos) + parseInt(data25[indice].renovados) + parseInt(data25[indice].regressos)
                Renovados = parseInt(data25[indice].renovados);
            }

            let anuidade_ajustada = 0;
            let indiceA = 0;
            if (typeof DataB !== 'undefined') {
                indiceA = DataB.findIndex(DataB => DataB.sec === cod_unidade)

                console.log("indiceA ", indiceA)
            };

            if (indiceA !== -1) {
                anuidade_ajustada = parseFloat(DataB[indiceA].anuidade_ajustada)
            }

            // "finan1": "7377341.84",
            // "finan2": "7524427.82",
            // "fidelizacao1": "750",
            // "fidelizacao2": "764",
            // "total1": "954",
            // "total2": "982"

            let indiceM = 0;

            let finan1 = 0;
            let finan2 = 0;
            let finan3 = 0;
            let fidelizacao1 = 0;
            let fidelizacao2 = 0;
            let fidelizacao3 = 0;
            let total1 = 0;
            let total2 = 0;
            let total3 = 0;


            if (typeof dataM !== 'undefined') {
                indiceM = dataM.findIndex(dataM => dataM.unidade === cod_unidade)
                console.log("indiceM ", indiceM)
            };

            if (indiceM !== -1) {
                finan1 = parseFloat(dataM[indiceM].finan1);
                finan2 = parseFloat(dataM[indiceM].finan2);
                finan3 = parseFloat(dataM[indiceM].finan3);
                fidelizacao1 = parseInt(dataM[indiceM].fidelizacao1);
                fidelizacao2 = parseInt(dataM[indiceM].fidelizacao2);
                fidelizacao3 = parseInt(dataM[indiceM].fidelizacao3);
                total1 = parseInt(dataM[indiceM].total1);
                total2 = parseInt(dataM[indiceM].total2);
                total3 = parseInt(dataM[indiceM].total3);
            }


            let PercentualMetaFinan1 = Math.round(((anuidade_ajustada * 100) / finan1) * 100) / 100;
            let PercentualMetaFinan2 = Math.round(((anuidade_ajustada * 100) / finan2) * 100) / 100;
            let PercentualMetaFinan3 = Math.round(((anuidade_ajustada * 100) / finan3) * 100) / 100;

            let PercentualMetal1 = (Total * 100) / total1;
            let PercentualMetal2 = (Total * 100) / total2;
            let PercentualMetal3 = (Total * 100) / total3;

            let APercentualMetal1 = Math.round(PercentualMetal1 * 100) / 100;
            let APercentualMetal2 = Math.round(PercentualMetal2 * 100) / 100;
            let APercentualMetal3 = Math.round(PercentualMetal3 * 100) / 100;

            let PercentualMetaReno1 = (Renovados * 100) / fidelizacao1;
            let PercentualMetaReno2 = (Renovados * 100) / fidelizacao2;
            let PercentualMetaReno3 = (Renovados * 100) / fidelizacao3;

            let APercentualMetaReno1 = Math.round(PercentualMetaReno1 * 100) / 100;
            let APercentualMetaReno2 = Math.round(PercentualMetaReno2 * 100) / 100;
            let APercentualMetaReno3 = Math.round(PercentualMetaReno3 * 100) / 100;

            row.push(APercentualMetal1);
            row.push(APercentualMetal2);
            row.push(APercentualMetal3);

            row.push(APercentualMetaReno1);
            row.push(APercentualMetaReno2);
            row.push(APercentualMetaReno3);

            row.push(PercentualMetaFinan1);
            row.push(PercentualMetaFinan2);
            row.push(PercentualMetaFinan3);

            console.log("row", row)
            return row;
        });
    }

    chartData.sort();
    chartData.unshift(["Unidade", "CRESCIMENTO 1", "CRESCIMENTO 2", "CRESCIMENTO 3", "FIDELIZAÇÃO 1", "FIDELIZAÇÃO 2", "FIDELIZAÇÃO 3", "FINANCEIRA 1", "FINANCEIRA 2", "FINANCEIRA 3"]);

    const options2 = {

        allowHtml: true,

    };
    const formatters = [
        {
            type: "NumberFormat",
            column: 1,
            options: {
                suffix: " %",
            },
        },
        {
            type: "ColorFormat",
            column: 1,
            ranges: [
                [0, 75, "white", "darkred"],
                [75, 90, "white", "red"],
                [90, 100, "white", "orange"],
                [100, 10000, "white", "green"],
            ],
        },
        {
            type: "NumberFormat",
            column: 2,
            options: {
                suffix: " %",
            },
        },
        {
            type: "ColorFormat",
            column: 2,
            ranges: [
                [0, 75, "white", "darkred"],
                [75, 90, "white", "red"],
                [90, 100, "white", "orange"],
                [100, 10000, "white", "green"],
            ],
        },
        {
            type: "NumberFormat",
            column: 3,
            options: {
                suffix: " %",
            },
        },
        {
            type: "ColorFormat",
            column: 3,
            ranges: [
                [0, 75, "white", "darkred"],
                [75, 90, "white", "red"],
                [90, 100, "white", "orange"],
                [100, 10000, "white", "green"],
            ],
        },
        {
            type: "NumberFormat",
            column: 4,
            options: {
                suffix: " %",
            },
        },
        {
            type: "ColorFormat",
            column: 4,
            ranges: [
                [0, 75, "white", "darkred"],
                [75, 90, "white", "red"],
                [90, 100, "white", "orange"],
                [100, 10000, "white", "green"],
            ],
        },
        {
            type: "NumberFormat",
            column: 5,
            options: {
                suffix: " %",
            },
        },
        {
            type: "ColorFormat",
            column: 5,
            ranges: [
                [0, 75, "white", "darkred"],
                [75, 90, "white", "red"],
                [90, 100, "white", "orange"],
                [100, 10000, "white", "green"],
            ],
        },
        {
            type: "NumberFormat",
            column: 6,
            options: {
                suffix: " %",
            },
        },
        {
            type: "ColorFormat",
            column: 6,
            ranges: [
                [0, 75, "white", "darkred"],
                [75, 90, "white", "red"],
                [90, 100, "white", "orange"],
                [100, 10000, "white", "green"],
            ],
        },
        {
            type: "NumberFormat",
            column: 7,
            options: {
                suffix: " %",
            },
        },
        {
            type: "ColorFormat",
            column: 7,
            ranges: [
                [0, 75, "white", "darkred"],
                [75, 90, "white", "red"],
                [90, 100, "white", "orange"],
                [100, 10000, "white", "green"],
            ],
        },
        {
            type: "NumberFormat",
            column: 8,
            options: {
                suffix: " %",
            },
        },
        {
            type: "ColorFormat",
            column: 8,
            ranges: [
                [0, 75, "white", "darkred"],
                [75, 90, "white", "red"],
                [90, 100, "white", "orange"],
                [100, 10000, "white", "green"],
            ],
        },
        {
            type: "NumberFormat",
            column: 9,
            options: {
                suffix: " %",
            },
        },
        {
            type: "ColorFormat",
            column: 9,
            ranges: [
                [0, 75, "white", "darkred"],
                [75, 90, "white", "red"],
                [90, 100, "white", "orange"],
                [100, 10000, "white", "green"],
            ],
        },

    ];


    const chartDataS13 = chartData.filter((linha) => linha[0] !== 'Mangueira');

    const getProgressBarVariant = (percentage) => {
        if (percentage >= 100) {
            return 'success'; // Verde
        }
        if (percentage >= 90) {
            return 'info';    // Azul
        }
        if (percentage >= 75) {
            return 'warning'; // Laranja
        }
        return 'danger';  // Vermelho
    };
    return (
        <div className="metas">
            <div className="sticky-top painel">

                <Navbar expand="lg" className="bg-body-tertiary">

                    <Navbar.Brand href="/">Santa Mônica Rede de Ensino</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">

                        <NavDropdown
                            title="UNIDADES"
                        >
                            {Experiment(perfil[0].perfil)}
                            <NavDropdown.Item href="/tesouraria">Tesouraria - Pagamentos</NavDropdown.Item>

                        </NavDropdown>

                        <Row>
                            <Form onSubmit={handleData}>

                                <Row>
                                    <Col xs="auto">
                                        <InputGroup>
                                            <InputGroup.Text id="basic-addon1">Data Início</InputGroup.Text>
                                            <Form.Group >
                                                {/* <Form.Label >Data Início: </Form.Label> */}
                                                <Form.Control
                                                    name="inicio"
                                                    type="date"
                                                    placeholder={dataInicio}
                                                    label="Data Início:"
                                                    className=" mr-sm-2" >

                                                </Form.Control>
                                            </Form.Group>
                                        </InputGroup>

                                    </Col>
                                    <Col xs="auto">
                                        <InputGroup>
                                            <InputGroup.Text id="basic-addon1">Data Fim</InputGroup.Text>
                                            <Form.Group >
                                                {/* <Form.Label htmlFor="floatingInput" >Data Início: </Form.Label> */}
                                                <Form.Control
                                                    name="fim"
                                                    type="date"
                                                    placeholder={dataFim}
                                                    label="Data Fim:"
                                                    className=" mr-sm-2" >
                                                </Form.Control>
                                            </Form.Group>
                                        </InputGroup>

                                    </Col>
                                    <Col xs="auto">
                                        <Button variant="primary" type="submit">
                                            Filtrar datas
                                        </Button>
                                    </Col>
                                    <Col xs="auto">
                                        <Button variant="primary" onClick={handleCiclo}> Todo Ciclo  </Button>
                                    </Col>
                                    <Col xs="auto">
                                        <Button variant="primary" onClick={handleHoje} > Até Hoje  </Button>
                                    </Col>
                                    <Col xs="auto">
                                        <Button variant="primary" onClick={handleSoHoje} >  Hoje {formatarData(diadehoje)}  </Button>
                                    </Col>
                                    <Col xs="auto">
                                        <Button variant="primary" onClick={(e) => { navigate("\login") }} > Sair  </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Row>
                    </Navbar.Collapse>
                </Navbar>


            </div>
            <br />
            <div className="container-fluid mt-3">
                {/* Verificamos se os dados estão prontos antes de renderizar a tabela */}
                {(!isLoading1 && !isLoading2 && !isLoading3) && chartData.length > 1 ? (
                    <Table striped bordered hover responsive="lg" className="tabela-metas">
                        <thead className="thead-dark">
                            <tr>
                                {/* Cria o cabeçalho dinamicamente a partir da primeira linha do chartData */}
                                {chartData[0].map((header, index) => (
                                    <th key={index}>{header}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {/* Pega apenas as linhas de dados (ignora o cabeçalho) e filtra 'Mangueira' */}
                            {chartData.slice(1).filter(row => row[0] !== 'Mangueira').map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {/* Mapeia cada célula da linha para uma <td> */}
                                    {row.map((cell, cellIndex) => (
                                        <td key={cellIndex} style={{ verticalAlign: 'middle' }}>
                                            {cellIndex === 0 ? (
                                                // Se for a primeira coluna, mostra o nome da unidade
                                                <strong>{cell}</strong>
                                            ) : (
                                                // Para as outras colunas, mostra a ProgressBar
                                                <div className="BarraDePgresso">
                                                    {/* Colocamos o texto em um span para facilitar o alinhamento e estilo */}
                                                    <span className="percentual-texto">{`${cell} %`}</span>

                                                    {/* A barra de progresso continua a mesma */}
                                                    <ProgressBar
                                                        now={cell}
                                                        style={{ height: '22px', fontSize: '0.85rem' }}
                                                        variant={getProgressBarVariant(cell)}
                                                        striped
                                                        animated={cell < 100}
                                                    />
                                                </div>
                                            )}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                ) : (
                    <p>Carregando dados das metas...</p>
                )}
            </div>

        </div>
    )

};


export default Metas_Painel;